import React from 'react';
import DatePicker from 'react-datepicker';

import DynamicFormHelpText from '../Components/DynamicFormHelpText';
import DynamicFormError from '../Components/DynamicFormError';

import definitions from '../../Style/LfStyleDefinitions';

const CustomDatePicker = ({ question, value = '', isValid, isTouched, invalidError, ...props }) => {
    const questionId = question.id;
    const questionText = question.questionText;
    const questionHelpText = question.helpText ? question.helpText : null;

    class CustomDateInput extends React.Component {
        render() {
            const inputValue = this.props.value ? this.props.value : '';
            return (
                <input
                    type="text"
                    readOnly
                    onClick={this.props.onClick}
                    value={inputValue} 
                    placeholder="ÅÅÅÅ-MM-DD"
                />
            )
        }
    }

    const selectedDate = typeof value !== 'undefined' && value && !isNaN(Date.parse(value))
        ? new Date(value)
        : null;

    return (
        <div className="dynamicFormDateWrapper">
            <label htmlFor={questionId}>
                {questionText}
                {questionHelpText &&
                    <DynamicFormHelpText questionGroupHelpText={questionHelpText} />
                }
            </label>

            <div className="dynamicFormDateInputContainer">
                <DatePicker
                    customInput={<CustomDateInput />}
                    placeholderText="ÅÅÅÅ-MM-DD"
                    dateFormat="yyyy-MM-dd"
                    withPortal={window.innerWidth <= definitions.breaks.small}
                    fixedHeight={true}
                    selected={selectedDate}
                    nextMonthButtonLabel=""
                    previousMonthButtonLabel=""
                    {...props}
                />
            </div>

            {!isValid && typeof isValid !== 'undefined' && isTouched &&
                <DynamicFormError>
                    {invalidError}
                </DynamicFormError>
            }
        </div>
    );
};

export default CustomDatePicker;